import { throwError } from 'rxjs';

export const formatDate = (dateString: string): string => {
  const date = new Date(dateString);
  const day = date.getDate().toString().padStart(2, '0');
  const month = (date.getMonth() + 1).toString().padStart(2, '0');
  const year = date.getFullYear();

  return `${day}/${month}/${year}`;
};

/**
 *
 * @param date Date type
 * @returns Date plus one
 */
export const addDay = (date: Date): Date => {
  date.setDate(date.getDate() + 1);
  return date;
};

export const formatDateTime = (dateTimeString: string): string => {
  const date = new Date(dateTimeString);
  const day = date.getDate().toString().padStart(2, '0');
  const month = (date.getMonth() + 1).toString().padStart(2, '0');
  const year = date.getFullYear();
  const hours = date.getHours().toString().padStart(2, '0');
  const minutes = date.getMinutes().toString().padStart(2, '0');
  const seconds = date.getSeconds().toString().padStart(2, '0');
  return `${day}/${month}/${year} ${hours}:${minutes}:${seconds}`;
};

/**
 * @param file Object file type
 * @param callback return Object image to url
 */
export const toImageObject = (file: any, callback: any) => {
  const reader = new FileReader();
  reader.readAsDataURL(file);
  reader.onload = callback;
};

/* Returns true if all elements of the object are complete, if not return false
 * @param object any type
 * @returns Boolean
 */
export const fullObject = (object: any): boolean => {
  let value = true;
  for (let clave in object) {
    if (object.hasOwnProperty(clave)) {
      if (!object[clave]) {
        value = false; // Retorna false si al menos un atributo está vacío
      }
    }
  }
  return value;
};

/**
 * @param obj Object key | value
 * @returns Count quantity
 */
export const countProperties = (obj: { [key: string]: any }): number => {
  return Object.keys(obj).length;
};

/**
 * @param dataUrl = 'data:image/jpeg;base64,/9j/4AAQSkZJRgABAQEAYABgAAD//gB...'; data chain here
 * @param filename = 'my_file'; file name here
 * @param mimeType MIME type of the file (can be 'image/jpeg', 'application/pdf', etc.)
 * @returns
 */
export const dataURLtoFile = (
  dataUrl: string,
  filename: string,
  mimeType: string
) => {
 switch (mimeType) {
  case 'image/jpeg':
    filename = 'img.jpeg';
    break;

  case 'image/png':
    filename = 'img.png';
    break;

  case 'application/pdf':
    filename = 'archivo.pdf';
    break;

  case 'application/msword':
    filename = 'archivo.doc';
    break;

  case 'application/vnd.openxmlformats-officedocument.wordprocessingml.document':
    filename = 'archivo.docx';
    break;
}
  if (!dataUrl || !filename || !mimeType) {
    throw new Error('Los datos de entrada son incorrectos.');
  }
  const arr = dataUrl.split(',');
  const bstr = atob(arr[1]);
  const n = bstr.length;
  const u8arr = new Uint8Array(n);

  for (let i = 0; i < n; i++) {
    u8arr[i] = bstr.charCodeAt(i);
  }

  return new File([u8arr], filename, { type: mimeType });
};

// /**
//  * @param dataurl = 'data:image/jpeg;base64,/9j/4AAQSkZJRgABAQEAYABgAAD//gB...'; data chain here
//  * @param filename = 'my_file'; file name here
//  * @param mimeType MIME type of the file (can be 'image/jpeg', 'application/pdf', etc.)
//  * @returns
//  */
// export const dataURLtoFile = (
//   dataurl: string,
//   filename: string,
//   mimeTypes?: string
// ) => {
//   if (!dataurl || !filename) {
//     throw new Error('Los datos de entrada son incorrectos.');
//   }
//   const arr = dataurl.split(',');
//   const mimeMatch = arr[0].match(/:(.*?);/);
//   if (!mimeMatch) {
//     throw new Error('No se pudo determinar el tipo MIME del archivo.');
//   }
//   const mimeType = mimeMatch[1];
//   const bstr = atob(arr[1]);
//   const n = bstr.length;
//   const u8arr = new Uint8Array(n);

//   for (let i = 0; i < n; i++) {
//     u8arr[i] = bstr.charCodeAt(i);
//   }

//   return new File([u8arr], filename, { type: mimeType });
// };

export const convertirPDFaBase64 = (pdfFile: File): Promise<string> => {
  return new Promise((resolve, reject) => {
    const reader = new FileReader();

    reader.onload = (event: ProgressEvent<FileReader>) => {
      if (event.target && event.target.result) {
        const base64String = event.target.result.toString().split(',')[1];
        resolve(base64String);
      } else {
        reject(new Error('Error al leer el archivo PDF.'));
      }
    };

    reader.onerror = (event) => {
      reject(new Error('Error al leer el archivo PDF.'));
    };

    reader.readAsDataURL(pdfFile);
  });
};

//* Handle errors
export const handleError = (error: any) => {
  return throwError(() => error);
};

/**
 * @description Check icon SVG
 */
export const checkIcon =
  '<svg xmlns="http://www.w3.org/2000/svg" class="ionicon" viewBox="0 0 512 512"><path d="M448 256c0-106-86-192-192-192S64 150 64 256s86 192 192 192 192-86 192-192z" fill="none" stroke="green" stroke-miterlimit="10" stroke-width="32"/><path fill="none" stroke="green" stroke-linecap="round" stroke-linejoin="round" stroke-width="32" d="M352 176L217.6 336 160 272"/></svg>';

/**
 * @description Minus icon SVG
 */
export const minusIcon =
  '<svg xmlns="http://www.w3.org/2000/svg" class="ionicon" viewBox="0 0 512 512"><path d="M448 256c0-106-86-192-192-192S64 150 64 256s86 192 192 192 192-86 192-192z" fill="none" stroke="orange" stroke-miterlimit="10" stroke-width="32"/><path fill="none" stroke="orange" stroke-linecap="round" stroke-linejoin="round" stroke-width="32" d="M336 256H176"/></svg>';

/**
 *
 */
export const notCheckIcon =
  '<svg xmlns="http://www.w3.org/2000/svg" class="ionicon" viewBox="0 0 512 512"><circle cx="256" cy="256" r="208" fill="none" stroke="red" stroke-miterlimit="10" stroke-width="32"/><path fill="none" stroke="red" stroke-miterlimit="10" stroke-width="32" d="M108.92 108.92l294.16 294.16"/></svg>';

/** @deprecated Manejo con callback */
export const convertImageToBase64 = (
  url: string,
  callback: (base64Image: string | null) => void
) => {
  const img = new Image();
  img.crossOrigin = 'Anonymous'; // Para permitir la carga de imágenes de otros dominios
  img.onload = () => {
    const canvas = document.createElement('canvas');
    canvas.width = img.width;
    canvas.height = img.height;

    const ctx = canvas.getContext('2d');
    ctx?.drawImage(img, 0, 0);

    const dataURL = canvas.toDataURL('image/png');
    callback(dataURL);
  };
  img.onerror = function (error) {
    console.error('Error loading image:', error);
    callback(null);
  };
  img.src = url;
};

/** @description Desde una url podemos convertir la imagen a base64 */
export const imgToBase64 = (url: string): Promise<string | null> => {
  return new Promise((resolve, rejected) => {
    const img = new Image();
    img.crossOrigin = 'anonymous';
    img.onload = () => {
      const canvas = document.createElement('canvas');
      canvas.width = img.width;
      canvas.height = img.height;

      const ctx = canvas.getContext('2d');
      if (ctx) {
        ctx.drawImage(img, 0, 0);
        const dataUrl = canvas.toDataURL('image/png');
        resolve(dataUrl);
      } else {
        console.error('Error on canvas context.');
        resolve(null);
      }
    };
    img.onerror = (error) => {
      console.error('Error on upload image: ', error);
      //! Se debería mandar el rejected, pero en este contexto necesito enviar el null
      //rejected(null)
      resolve(null);
    };
    img.src = url;
  });
};

//Función para armar lista de años.
export const yearList = (
  startYear: number
): { label: string; value: any }[] => {
  const currentYear = new Date().getFullYear();
  const years: { label: string; value: any }[] = [];

  for (let year = startYear; year <= currentYear; year++) {
    years.push({ label: 'year', value: year });
  }

  return years;
};

export const kpi = [
  'Cantidad de Km de Contratistas',
  'Cantidad de Km de Subcontratistas',
  'Cantidad de frenadas bruscas',
  'Cantidad de inspecciones vehiculares realizadas',
  'Cantidad de observaciones de seguridad, intervenciones o violaciones a las Reglas de Salvar Vidas relacionadas a Seguridad de Transporte',
  'Cantidad de entrenamientos de manejo realizados',
  'Cantidad de conversaciones documentadas de feedback relacionadas a desempeño en el manejo',
  'Cantidad de reuniones de seguridad donde se traten temas de seguridad vial',
  'Gestión de viajes',
  'Inspecciones vehiculares',
];

export const hse = [
  'Cantidad de Horas de Contratistas',
  'Cantidad de Horas de Sub Contratistas',
  'Cantidad de horas de capacitación realizadas según cronograma',
  'Cantidad de Observaciones HSSE',
  'Cantidad de Orientaciones en sitio realizadas',
  'Cantidad de Permisos de trabajo',
  'Cantidad de revisiones de ATS realizadas',
  'Cantidad de Auditorias de HSSE realizadas',
  'Cantidad de Inspecciones generales realizadas',
  'Cantidad de Simulacros/ejercicios de escritorio realizados',
  'Cantidad de Visitas de líderes',
  'Cantidad de Cuasi incidentes (Near Miss)',
  'Cantidad de casos de incidentes de alto potencial (HiPo)',
  'Cantidad de casos de incidentes con Daño a la propiedad (PLD)',
  'Cantidad de casos de incidentes con tratamiento médico (MTC)',
  'Cantidad de casos de incidentes de primeros auxilios (FAC)',
  'Cantidad de casos de incidentes de trabajos restringidos (RWC)',
  'Cantidad de casos de incidentes con días perdidos (DAFWC)',
  'Cantidad de Derrames',
  'Cantidad de casos de incidentes con pérdida de contención primaria (LOPC)',
  'Violaciones a las 9 Reglas para salvar Vidas (RPSV)',
  'Cantidad de Fatalidades',
  'Cantidad de Incidentes Vehiculares',
];
